import { createContext, useContext } from "react";

const HistoryContext = createContext({});

export const HistoryContextProvider = HistoryContext.Provider;
export const HistoryContextConsumer = HistoryContext.Consumer;

export const useHistoryContext = () => useContext(HistoryContext);

export default HistoryContext;
